// Signup attribution through the `utm_campaign` query param.
// Partners (ESOs) share links like `/signup?utm_campaign=Latam%20Impacto`. When a NEW user signs up
// with this param, we send it as the profile's `signup_campaign` (a raw value the user never sees).
// Logins of existing accounts ignore the param.

export const UTM_CAMPAIGN_PARAM = 'utm_campaign';

/**
 * Returns the signup campaign from the `utm_campaign` query param, or null if there is none.
 * URLSearchParams decodes both `%20` and `+` as spaces. The backend truncates long values.
 */
export const getSignupCampaign = search =>
  new URLSearchParams(search).get(UTM_CAMPAIGN_PARAM)?.trim() || null;

/**
 * Returns the query params that must survive navigation between /login and /signup:
 * the custom link params (only as a pair) and the signup campaign param.
 */
export const getAuthLinkSearch = search => {
  const currentParams = new URLSearchParams(search);
  const authParams = new URLSearchParams();

  const organization = currentParams.get('organization');
  const program = currentParams.get('program');
  if (organization && program) {
    authParams.set('organization', organization);
    authParams.set('program', program);
  }

  const utmCampaign = currentParams.get(UTM_CAMPAIGN_PARAM);
  if (utmCampaign) authParams.set(UTM_CAMPAIGN_PARAM, utmCampaign);

  const authSearch = authParams.toString();
  return authSearch ? `?${authSearch}` : '';
};
